var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"thumb",class:_vm.classes,style:(`left:calc(${_vm.boundValue * 100}% - 8px)`),on:{"touchstart":_vm.mouseDown,"mousedown":_vm.mouseDown}},[_c('div',{ref:"halo",staticClass:"halo"})])
}
var staticRenderFns = []

export { render, staticRenderFns }